import { Theme } from "@mui/material/styles";

export const getSwitcherComponents = (sunoTheme: Theme) => ({
  MuiPickersArrowSwitcher: {
    styleOverrides: {
      root: {
        width: sunoTheme.spacing(9.5),
        marginRight: sunoTheme.spacing(1),
      },
    },
  },
});
